import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';

// Languages
import en from './locales/en.json';
import de from './locales/de.json';
import ar from './locales/ar.json';
import ua from './locales/ua.json';

i18n.use(detector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: en,
            },

            de: {
                translation: de,
            },

            ar: {
                translation: ar,
            },

            ua: {
                translation: ua,
            },
        },

        fallbackLng: 'en', // use en if detected lng is not available

        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
